import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiXcode,
  SiAndroidstudio,
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiMacos,
} from "react-icons/si";
import { IoLogoReact } from "react-icons/io5";


function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiXcode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAndroidstudio />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>




      <Col xs={4} md={2} className="tech-icons">
        <SiMacos />
      </Col>
    
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack />
      </Col>
    
    </Row>
  );
}

export default Toolstack;
